<template>
    <div>
        <div class="modal fade" id="layoutCartaoModal" tabindex="-1" role="dialog"
            aria-labelledby="layoutCartaoModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-md modal-dialog-scrollable" role="document">
                <div v-if="layout" class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="layoutCartaoModalLabel">Layout Cartão de Crédito</h5>
                        <button type="button" class="close" @click="fechar()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12 col-md-12">
                                <az-input label="Nome" placeholder="Nome do Layout..." v-model="layout.st_nome" />
                            </div>
                        </div>
                        <div v-for="(coluna, index) in layout.js_layout" :key="index" class="form-row">
                            <AzSubTitle title="Número das Colunas" v-if="index == 2" style="width: 100%; padding-top: 10px;"></AzSubTitle>
                            <div class="col col-12 col-md-12">
                                <az-input :label="coluna.st_search" v-if="!coluna.checkbox" sizing="sm" v-model="coluna.in_numero" />
                                <az-input type="checkbox-group" :label="coluna.st_search" sizing="sm" v-else class="my-3" v-model="coluna.in_numero" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar()">Fechar</button>
                        <button @click="salvar()" type="button" class="btn btn-primary">Salvar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import azInput from "@/components/shared/forms/AzInput.vue";
import $ from 'jquery';
import AzSubTitle from "@/components/util/AzSubTitle.vue";

export default {

    components: {
        AzSubTitle,
        azInput
    },

    data() {
        return {
            layout: null,

            campos: [

                {
                    'st_search': 'Ignorar Linhas de Cabeçalho (quantidade de linhas)',
                    'st_nome_coluna': 'ignorar_linhas_cabecalho',
                    'in_numero': 1
                },

                {
                    'st_search': 'Consolidar lançamentos por Bandeira e Forma de Pagamento',
                    'st_nome_coluna': 'consolidar_lancamentos',
                    'in_numero': false,
                    'checkbox': true,
                },

                {
                    'st_search': 'NSU',
                    'st_nome_coluna': 'nsu',
                    'in_numero': ''
                },

                {
                    'st_search': 'Número Autorização',
                    'st_nome_coluna': 'autorizacao',
                    'in_numero': ''
                },

                {
                    'st_search': 'Data de Recebimento',
                    'st_nome_coluna': 'recebimento',
                    'in_numero': ''
                },

                {
                    'st_search': 'Data Original de Venda',
                    'st_nome_coluna': 'original',
                    'in_numero': ''
                },

                {
                    'st_search': 'Data de Vencimento Original',
                    'st_nome_coluna': 'vencimento',
                    'in_numero': ''
                },

                {
                    'st_search': 'Valor Bruto',
                    'st_nome_coluna': 'valor_bruto',
                    'in_numero': ''
                },

                {
                    'st_search': 'Valor do Desconto',
                    'st_nome_coluna': 'valor_desconto',
                    'in_numero': ''
                },

                {
                    'st_search': 'Valor Líquido',
                    'st_nome_coluna': 'valor_liquido',
                    'in_numero': ''
                },

                {
                    'st_search': 'Bandeira',
                    'st_nome_coluna': 'bandeira',
                    'in_numero': ''
                },

                {
                    'st_search': 'Forma de Pagamento',
                    'st_nome_coluna': 'forma_pagamento',
                    'in_numero': ''
                },

                {
                    'st_search': 'Parcela',
                    'st_nome_coluna': 'tipo_parcela',
                    'in_numero': ''
                },

                {
                    'st_search': 'Quantidade Parcelas',
                    'st_nome_coluna': 'quantidade_parcela',
                    'in_numero': ''
                },

                {
                    'st_search': 'Estabelecimento',
                    'st_nome_coluna': 'estabelecimento',
                    'in_numero': ''
                },

                {
                    'st_search': 'Máquina',
                    'st_nome_coluna': 'maquina',
                    'in_numero': ''
                }

            ]

        }
    },

    methods: {
        open(layout = null) {

            if (layout) {
                this.layout = layout;
                this.layout.js_layout = this.campos.map((campo) => {
                    const index = this.layout.js_layout.findIndex((item) => item.st_nome_coluna === campo.st_nome_coluna);
                    if (index === -1) {
                        return {
                            ...campo,
                            in_numero: ''
                        }
                    } else {
                        return {
                            ...this.layout.js_layout[index],
                            st_search: campo.st_search
                        };
                    }
                });


            } else {
                this.layout = {
                    st_nome: '',
                    js_layout: this.campos,
                    fl_ativo: true
                }
            }

            $('#layoutCartaoModal').modal('show');
        },

        fechar() {
            $('#layoutCartaoModal').modal('hide');
        },

        salvar() {
            this.$util.atualizar(this, {
                service: 'layout-cartao-credito',
                dados: {
                    ...this.layout,
                },
                toast: true,
                callback: () => {
                    this.fechar();
                    this.$emit('refresh');
                }
            });
        }

    }
}
</script>

<style scoped></style>
